import React, { useState } from 'react';
import { toast } from 'sonner';
import { LinkedinIcon, MailIcon, FileTextIcon, UsersIcon } from 'lucide-react';
import { useI18n } from '../lib/i18n';
export function Contact() {
  const {
    t
  } = useI18n();
  const [form, setForm] = useState({
    name: '',
    email: '',
    org: '',
    reason: 'colab',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setTimeout(() => {
      toast.success(t('contact.success'));
      setForm({
        name: '',
        email: '',
        org: '',
        reason: 'colab',
        message: ''
      });
      setSubmitting(false);
    }, 600);
  };
  const inputClass = 'w-full px-4 py-3 bg-white border border-black/[0.08] rounded-lg text-[#0A0A0F] text-sm placeholder-[#8A8A95] focus:outline-none focus:border-violet-electric/50 transition';
  const links = [{
    icon: LinkedinIcon,
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/lionelgraggio/',
    external: true
  }, {
    icon: MailIcon,
    label: 'info@clvn-lrr.com',
    href: 'mailto:info@clvn-lrr.com',
    external: false
  }, {
    icon: FileTextIcon,
    label: 'Papers',
    href: 'https://doi.org/10.5281/zenodo.15438330',
    external: true
  }, {
    icon: UsersIcon,
    label: 'Collaborations',
    href: 'mailto:info@clvn-lrr.com?subject=Collaboration',
    external: false
  }];
  return <section className="w-full bg-[#FAFAFA] py-32 px-6 md:px-12 border-t border-black/[0.06]" data-id="element-95" data-mp="3657v8pex3w0a">
      <div className="max-w-6xl mx-auto" data-id="element-96" data-mp="2s5gist41unoe">
        <h2 className="font-display text-4xl md:text-5xl text-[#0A0A0F] mb-16 tracking-tight" data-id="element-97" data-mp="2s6rmyu1epxg1">
          {t('contact.title')}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-98" data-mp="qcscgaw3zk4e">
          <form onSubmit={handleSubmit} className="lg:col-span-3 space-y-5" data-id="element-99" data-mp="qb7escehzl2b">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-100" data-mp="uducgtxuo07f">
              <div data-id="element-101" data-mp="23cn3gss9x5lc">
                <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-102" data-mp="23d57wcp3aq4c">
                  {t('contact.name')}
                </label>
                <input type="text" required value={form.name} onChange={e => setForm({
                ...form,
                name: e.target.value
              })} className={inputClass} data-id="element-103" data-mp="1ubxdi5pp29fj" />
              </div>
              <div data-id="element-104" data-mp="2d9i0f78wexxi">
                <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-105" data-mp="2d8q6s1yv3a9v">
                  {t('contact.email')}
                </label>
                <input type="email" required value={form.email} onChange={e => setForm({
                ...form,
                email: e.target.value
              })} className={inputClass} data-id="element-106" data-mp="35pst1fkigk7a" />
              </div>
            </div>
            <div data-id="element-107" data-mp="3i8wsxb8vr6gv">
              <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-108" data-mp="3i8f06olffadp">
                {t('contact.org')}
              </label>
              <input type="text" value={form.org} onChange={e => setForm({
              ...form,
              org: e.target.value
            })} className={inputClass} data-id="element-109" data-mp="3m7x9so7srz18" />
            </div>
            <div data-id="element-110" data-mp="9slgk0vstisf">
              <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-111" data-mp="9t4tf36ldgzl">
                {t('contact.reason')}
              </label>
              <select value={form.reason} onChange={e => setForm({
              ...form,
              reason: e.target.value
            })} className={inputClass} data-id="element-112" data-mp="itjfi4rdr045">
                <option value="colab" data-id="element-113" data-mp="13ejcfu1saf5">{t('contact.reasons.colab')}</option>
                <option value="press" data-id="element-114" data-mp="evug4ywcvc7m">{t('contact.reasons.press')}</option>
                <option value="research" data-id="element-115" data-mp="9ykiwx2q5w98">
                  {t('contact.reasons.research')}
                </option>
                <option value="other" data-id="element-116" data-mp="3iduqultapvox">{t('contact.reasons.other')}</option>
              </select>
            </div>
            <div data-id="element-117" data-mp="3edkdup73650k">
              <label className="block text-xs uppercase tracking-widest text-[#4A4A55] mb-2 font-medium" data-id="element-118" data-mp="3ee3qprhvq37q">
                {t('contact.message')}
              </label>
              <textarea rows={5} required value={form.message} onChange={e => setForm({
              ...form,
              message: e.target.value
            })} className={`${inputClass} resize-none`} data-id="element-119" data-mp="3naup4ajwlu5h" />
            </div>
            <button type="submit" disabled={submitting} className="px-8 py-3 bg-[#0A0A0F] hover:bg-[#2A2A35] disabled:opacity-50 text-white text-sm font-medium rounded-lg transition" data-id="element-120" data-mp="2pjzco5rim3kf">
              {submitting ? '...' : t('contact.send')}
            </button>
          </form>

          <aside className="lg:col-span-2 lg:pl-8 lg:border-l border-black/[0.08]" data-id="element-121" data-mp="348m1qz6y29ou">
            <h3 className="text-xs uppercase tracking-widest text-violet-deep mb-6 font-medium" data-id="element-122" data-mp="388w84cynf248">
              {t('contact.links')}
            </h3>
            <ul className="space-y-4" data-id="element-123" data-mp="2zgub6onsg3yp">
              {links.map(link => {
              const Icon = link.icon;
              return <li key={link.label} data-id="element-124" data-mp="3n5wrnt6orqrm">
                    <a href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noopener noreferrer' : undefined} className="flex items-center gap-3 text-[#2A2A35] hover:text-[#0A0A0F] transition group" data-id="element-125" data-mp="3n4u2pqsxbyec">
                      <span className="w-9 h-9 flex items-center justify-center rounded-lg border border-black/[0.08] bg-white group-hover:border-violet-electric/40 transition" data-id="element-126" data-mp="3ru688fc2e0zl">
                        <Icon className="w-4 h-4" aria-hidden="true" data-id="element-127" data-mp="3iv1ahb8buboh" />
                      </span>
                      <span className="text-sm" data-id="element-128" data-mp="3e39hku1p7tv6">{link.label}</span>
                    </a>
                  </li>;
            })}
            </ul>
          </aside>
        </div>
      </div>
    </section>;
}